{
    "name": "blink",
    "duration": 0.433333367,
    "keyframes": {
        "mal_body/brow_left/m_LocalRotation.x": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "mal_body/brow_left/m_LocalRotation.y": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "mal_body/brow_left/m_LocalRotation.z": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "mal_body/brow_left/m_LocalRotation.w": [
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0
        ],
        "mal_body/brow_right/m_LocalRotation.x": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "mal_body/brow_right/m_LocalRotation.y": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "mal_body/brow_right/m_LocalRotation.z": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "mal_body/brow_right/m_LocalRotation.w": [
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0
        ],
        "mal_body/eye_left/m_LocalRotation.x": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "mal_body/eye_left/m_LocalRotation.y": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "mal_body/eye_left/m_LocalRotation.z": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "mal_body/eye_left/m_LocalRotation.w": [
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0
        ],
        "mal_body/eye_right/m_LocalRotation.x": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "mal_body/eye_right/m_LocalRotation.y": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "mal_body/eye_right/m_LocalRotation.z": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "mal_body/eye_right/m_LocalRotation.w": [
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0
        ],
        "mal_body/brow_left/m_LocalPosition.x": [
            -0.220026389, -0.220026389, -0.220026389, -0.220026389, -0.220026389,
            -0.220026389, -0.220026389, -0.220026389, -0.220026389, -0.220026389,
            -0.220026389, -0.220026389, -0.220026389, -0.220026389
        ],
        "mal_body/brow_left/m_LocalPosition.y": [
            0.6876974, 0.681677163, 0.6667882, 0.647787, 0.629429638, 0.616472661,
            0.6136724, 0.625785053, 0.65369755, 0.683373, 0.6971821, 0.6947232, 0.690156341,
            0.6876974
        ],
        "mal_body/brow_left/m_LocalPosition.z": [
            0.4464692, 0.4464692, 0.4464692, 0.4464692, 0.4464692, 0.4464692, 0.4464692,
            0.4464692, 0.4464692, 0.4464692, 0.4464692, 0.4464692, 0.4464692, 0.4464692
        ],
        "mal_body/brow_right/m_LocalPosition.x": [
            0.212881982, 0.212881982, 0.212881982, 0.212881982, 0.212881982, 0.212881982,
            0.212881982, 0.212881982, 0.212881982, 0.212881982, 0.212881982, 0.212881982,
            0.212881982, 0.212881982
        ],
        "mal_body/brow_right/m_LocalPosition.y": [
            0.6876974, 0.681677163, 0.6667882, 0.647787, 0.629429638, 0.616472661,
            0.6136724, 0.625785053, 0.65369755, 0.683373, 0.6971821, 0.6947232, 0.690156341,
            0.6876974
        ],
        "mal_body/brow_right/m_LocalPosition.z": [
            0.4467821, 0.4467821, 0.4467821, 0.4467821, 0.4467821, 0.4467821, 0.4467821,
            0.4467821, 0.4467821, 0.4467821, 0.4467821, 0.4467821, 0.4467821, 0.4467821
        ],
        "mal_body/eye_left/m_LocalPosition.x": [
            -0.223240286, -0.223240286, -0.223240286, -0.223240286, -0.223240286,
            -0.223240286, -0.223240286, -0.223240286, -0.223240286, -0.223240286,
            -0.223240286, -0.223240286, -0.223240286, -0.223240286
        ],
        "mal_body/eye_left/m_LocalPosition.y": [
            0.485299051, 0.485299051, 0.485299051, 0.485299051, 0.485299051, 0.485299051,
            0.485299051, 0.485299051, 0.485299051, 0.485299051, 0.485299051, 0.485299051,
            0.485299051, 0.485299051
        ],
        "mal_body/eye_left/m_LocalPosition.z": [
            0.456686378, 0.456686378, 0.456686378, 0.456686378, 0.456686378, 0.456686378,
            0.456686378, 0.456686378, 0.456686378, 0.456686378, 0.456686378, 0.456686378,
            0.456686378, 0.456686378
        ],
        "mal_body/eye_right/m_LocalPosition.x": [
            0.222007245, 0.222007245, 0.222007245, 0.222007245, 0.222007245, 0.222007245,
            0.222007245, 0.222007245, 0.222007245, 0.222007245, 0.222007245, 0.222007245,
            0.222007245, 0.222007245
        ],
        "mal_body/eye_right/m_LocalPosition.y": [
            0.5001766, 0.5001766, 0.5001766, 0.5001766, 0.5001766, 0.5001766, 0.5001766,
            0.5001766, 0.5001766, 0.5001766, 0.5001766, 0.5001766, 0.5001766, 0.5001766
        ],
        "mal_body/eye_right/m_LocalPosition.z": [
            0.456686348, 0.456686348, 0.456686348, 0.456686348, 0.456686348, 0.456686348,
            0.456686348, 0.456686348, 0.456686348, 0.456686348, 0.456686348, 0.456686348,
            0.456686348, 0.456686348
        ],
        "mal_body/brow_left/m_LocalScale.x": [
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0
        ],
        "mal_body/brow_left/m_LocalScale.y": [
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0
        ],
        "mal_body/brow_left/m_LocalScale.z": [
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0
        ],
        "mal_body/brow_right/m_LocalScale.x": [
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0
        ],
        "mal_body/brow_right/m_LocalScale.y": [
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0
        ],
        "mal_body/brow_right/m_LocalScale.z": [
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0
        ],
        "mal_body/eye_left/m_LocalScale.x": [
            1.0, 1.02619374, 1.08168077, 1.13181984, 1.164684, 1.17958951, 1.11930108,
            1.00733662, 0.947048, 0.9607779, 0.9862702, 1.0, 1.0, 1.0
        ],
        "mal_body/eye_left/m_LocalScale.y": [
            1.0, 0.768678546, 0.333309442, 0.08178577, 0.06410886, 0.0615835823,
            0.344965845, 0.8712472, 1.15462923, 1.11453557, 1.04009366, 1.0, 1.0, 1.0
        ],
        "mal_body/eye_left/m_LocalScale.z": [
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0
        ],
        "mal_body/eye_right/m_LocalScale.x": [
            1.0, 1.02619374, 1.08168077, 1.13181984, 1.164684, 1.17958951, 1.11930108,
            1.00733662, 0.947048, 0.9607779, 0.9862702, 1.0, 1.0, 1.0
        ],
        "mal_body/eye_right/m_LocalScale.y": [
            1.0, 0.768678546, 0.333309442, 0.08178577, 0.06410886, 0.0615835823,
            0.344965845, 0.8712472, 1.15462923, 1.11453557, 1.04009366, 1.0, 1.0, 1.0
        ],
        "mal_body/eye_right/m_LocalScale.z": [
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0
        ]
    },
    "wrapMode": 0,
    "guid": "f0862f30902aa4ea7b6416081bdb78cc",
    "assetPath": "Assets/Characters/Mal/mal@blink.fbx"
}
